<template>
    <div class="headerBox">
        <div class="title_header">
            <div class="logo">
                <img src="../assets/home/logo2.png" alt="">
            </div>
            <div class="navRight">
                <div class="nav">
                    <ul>
                        <li class="nav_item" v-for="item in menus" :key="item.id" @mouseover="item.show=!item.show" @mouseout="item.show=!item.show">
                            <router-link  class="nav_url" :to="item.url" exact>{{item.name}}</router-link>
                            <ul class="subMenus" v-if="item.subMenus" v-show="item.show">
                                <li v-for="item1 in item.subMenus" :key="item1.id" class="subList">
                                    <!-- <a  href="" class="subUrl" exact>{{item1.name}}</a> -->
                                    <router-link :to="item1.url1" class="subUrl" exact>{{item1.name}}</router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="loginBox" v-show="!loginUserFlag">
                    <router-link to="/login">登录</router-link>
                    <router-link to="/registration">注册</router-link>
                </div>
                <div v-show="loginUserFlag" class="person">
                    <div >
                        <div class="person_img">
                           <router-link to="/message">
                             <img src="../assets/home/ico_noti.png" alt="" >
                           </router-link>
                        </div>
                        <div class="person_img" @mouseover="showUser=true"  >
                            <img src="../assets/home/ico_user.png" alt="" >
                        </div>

                    </div>
                    <div class="person_infoBox"  v-show="showUser"  @mouseleave="showUser=false" >
                        <div class="person_title">{{ loginUser.doctorVo.cnName }}</div>
                      <router-link to="/address">
                        <div  class="perInfo_item">
                            <img src="../assets/home/account_img4.gif" alt="">
                            配送地址管理
                        </div>
                      </router-link>
                       <router-link to="/password">
                        <div class="perInfo_item">
                            <img src="../assets/home/account_img2.gif" alt="">
                            更改密码
                        </div>
                       </router-link>
                       <router-link to="/agreement">
                       <div class="perInfo_item">
                            <img src="../assets/home/account_img6.gif" alt="">
                          个人信息使用协议
                        </div>
                      </router-link>
                      <div class="perInfo_item"  @click="loginOut">
                            <img src="../assets/home/account_img8.gif" alt="">
                            注销
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import request from "@/util/request";
import {cateType} from "@/util/content";

export default {
    data(){
        return {
          newsCates:[],
          proCates:[],
           loginUserFlag:false,
            menus:[
                {id:1,name:'首页',url:'/home',show:false},
                {id:2,name:'新闻动态',url:'/news',show:false},
                {id:3,name:'产品中心',url:'/product',show:false,subMenus:[]},
                {id:4,name:'卓然数字化',url:'/zhuoran',show:false},
                {id:5,name:'病例库',url:'/cases',show:false},
                {id:6,name:'售后服务',url:'/instructions',show:false,subMenus: [
                    {id:1,name:'使用说明',url1:'/instructions'},
                    {id:2,name:'CLC认证',url1:'CLCCertification'}
                  ]},
                {id:7,name:'联系我们',url:'/contact',show:false,subMenus:[
                    {id:1,name:'诚聘代理',url1:'/recruitment'},
                    {id:2,name:'人才招聘',url1:'/talent'},
                    {id:3,name:'留言板',url1:'/message'},
                ]},
            ],
            active:true,
            showUser:false,
            loginUser:{doctorVo:{}}
        }
    },
    created() {
     this.loginUserFlag = localStorage.getItem('user') ? true : false
    },
  mounted() {
    this.initCates()
    window.addEventListener('storage', (e) => {
      console.log(e)
      const us = localStorage.getItem('user') ;
      if(us){
        this.loginUserFlag = true
        this.loginUser=JSON.parse(localStorage.getItem('user'))

      }else{
        this.loginUserFlag = false
      }
    });
    window.addEventListener("setItemEvent", (e) => {
      console.log(e)
      const us = localStorage.getItem('user') ;
      if(us){
        this.loginUserFlag = true
        this.loginUser=JSON.parse(localStorage.getItem('user'))
      }else {
        this.loginUserFlag = false
      }
    });
  },
  methods:{
    loginOut(){
      this.loginUserFlag = false
      localStorage.clear()
      this.$router.push({path:'/login'})
    },
    initCates(){
      request.get('/system/category/getAll').then(res=>{
        const allCatelogs = res.data
        this.proCates = allCatelogs.filter(e=>e.type===cateType.product)
        if(this.proCates && this.proCates.length>0){
          this.proCates.forEach(e=>{
           this.menus[2].subMenus.push({id:e.id,name:e.name,url1:'/product?cateId='+e.id})
          })
        }
        this.newsCates = allCatelogs.filter(e=>e.type===cateType.news)
      })
    }
},

}
</script>

<style lang="scss" scoped>
    .headerBox {
        width: 100%;
        height: 80px;
        background: #fff;
    }
    .title_header {
        width: 1600px;
        height: 80px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .headerBox .logo img{
        width: 219px;
        height: 45px;
    }
    .headerBox .navRight {
        width: 1041px;
        height: 80px;
        display: flex;
        justify-content: space-between;

    }

    .navRight .nav ul .nav_item{
        float: left;
        height: 80px;
        line-height: 80px;
        margin-right: 40px;


    }
    .navRight .nav ul .nav_item .nav_url  {
        display: inline-block;
        height: 80px;
        line-height: 80px;
        font-size: 15px;
        color: #333;
    }
    .loginBox {
        height: 80px;
        line-height: 80px;
    }
    .loginBox a {
        margin-right: 30px;
        font-size: 15px;
        color: #333;
    }
    .nav_active {
        color: #81D8CF;border-bottom: 1px solid #81D8CF;
    }
    a.router-link-exact-active {
		color: #81D8CF !important;
        border-bottom: 1px solid #81D8CF;
    }
    .subMenus  {
        width: 90px;
        background: #fff;
        position: absolute;
        z-index: 999;
    }
    .subMenus .subList .subUrl{
        display: block;
        width: 80px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-bottom: 1px solid #eeeeee;
    }
    @media (max-width: 1600px) {
        .title_header {
        width: 1200px;
        height: 80px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .headerBox .logo img{
        width: 219px;
        height: 45px;
    }
    .headerBox .navRight {
        width: 880px;
        height: 80px;
        display: flex;
        justify-content: space-between;

    }
    }

     /*个人中心  */
     .person {
        margin-top: 22px;
        position: relative;
    }
    .person_img {
        float: left;
        margin-right: 20px;
        width: 38px;
        height: 38px;
        text-align: center;
        background: #515151;
        vertical-align: middle;
        border-radius: 50%;
        /* margin-top: 50px; */
    }

    .person_img img{
        margin-top: 5px;
    }

    .person_img:hover {
        background: #81d8cf;
        cursor: pointer;
    }
    .person_infoBox {
        position: absolute;
        top: 65px;
        left: -50px;
        z-index: 999;
        /* width: 200px; */
        border: 1px solid #e1e1e1;
        border-radius: 8px;
        background: #fff;
        box-shadow: 0 5px 5px #7b7b7b30;

    }
    .person_infoBox::before{
        content: '';
        display: inline-block;
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-bottom: 10px solid #f9f9f9;
        position: absolute;
        top: -18px;
        left: 116px;
    }
    .person_title {
        text-align: center;
        font-size: 14px;
        padding: 13px 0;
        background: #f9f9f9;
        margin-bottom: 20px;
    }
    .perInfo_item {
        width: 250px;
        height: 30px;
        line-height: 30px;
        margin-bottom: 20px;
        padding:0 30px;
        box-sizing: border-box;
        border-bottom:1px dashed #eee;
        cursor: pointer;
    }
    .perInfo_item img {
        vertical-align: middle;
    }

</style>
